import type { Balances } from "@/entities/balance";

export interface User {
  _id: string;
  role: Roles;
  username: string;
  createdAt: Date;
  tgUsername: string;
  balances: Balances;
  totalIncome: number;
  permissions: UserPermissions[];
  code: string;
  accessToken?: string;
  refreshToken?: string;
  isBanned: boolean;
}

export enum UserPermissions {
  SMS = "sms",
  TRAFFIC = "traffic",
  CONSTRUCTOR_BOT = "constructor_bot",
  TG_TRACK_INTEGRATION = "tg_track_integration",
  CREATE_LEAD = "create_lead",
  CREATE_CLAN = "create_clan",
  CHECK_LEAD_LINK = "check_lead_link",
}

export enum Roles {
  Worker = "worker",
  Manager = "manager",
  TeamLead = "teamlead",
  MasterTeamLead = "master_teamlead",
  Head = "head",
}
